import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-差旅报销审批",
  "use": "icon-差旅报销审批-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-差旅报销审批\"><title>oa-icon</title><path d=\"M5.16,4.3V11H6.49v.89H4.71a.45.45,0,0,1-.45-.45h0V3.85a.45.45,0,0,1,.45-.45h7.12a.45.45,0,0,1,.45.45h0V9h-.89V4.3ZM7.83,8.75V7.41H6.49V6.52H7.65l-.91-.91L7.37,5l.91.91L9.19,5l.63.63-.9.9h1.14v.89H8.72V8.75Z\" /><path d=\"M13.44,9.64a.69.69,0,0,0-.93-.19l-1.43.83L9,9.14l-.77.45L9.79,11l-1.14.66-1-.46-.58.33,1.85,1.22a.45.45,0,0,0,.47,0l.73-.42,3.08-1.78a.67.67,0,0,0,.24-.91l0,0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/差旅报销审批.svg
// module id = xwnW
// module chunks = 166